import { render } from "./EditLessonAccessModal.vue?vue&type=template&id=3237bc08"
import script from "./EditLessonAccessModal.vue?vue&type=script&lang=js"
export * from "./EditLessonAccessModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__